// Angular
import { Component, EventEmitter, Output, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'masthead-logout',
    encapsulation: ViewEncapsulation.Emulated,
    template: require('./logout.component.html'),
    styles: [`
        .masthead__wrapper:hover .masthead__icon {
            -webkit-animation: shake-logout 1s ease-in-out;
            animation: shake-logout 1s ease-in-out;
        }
        
        @keyframes shake-logout {
            0% {
                transform: translateX(0);
            }
        
            20% {
                transform: translateX(3px);
            }
        
            40% {
                transform: translateX(3px);
            }
        
            60% {
                transform: translateX(3px);
            }
        
            80% {
                transform: translateX(3px);
            }
        
            100% {
                transform: translateX(0);
            }
        }
    `]
})

export class LogoutComponent {

    // Ouput
	@Output('logout') logout = new EventEmitter(); 
    constructor() { }
    clickedLogout() {
        this.logout.emit();
    }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/logout/logout.component.ts